import { http } from "msw";

/**
 * Matrix integration endpoints.
 *
 * Matrix UI on main currently only calls /api/v1/healthcheck (covered by
 * auth handlers) and reads its instructions via the standard
 * /api/v2/instructions/data/matrix path (handlers/products.ts).
 *
 * This file exists so we have a place to add matrix-specific stubs as
 * the integration grows — keeping the handler split consistent with the
 * other integrations.
 */
export const matrixHandlers: ReturnType<typeof http.get>[] = [
  // No matrix-specific endpoints yet. When matrix's UI starts calling
  // /api/v1/matrix/<something>, add the handler here and the catch-all in
  // handlers/proxy.ts will stop matching.
];
